import * as z from 'zod';
import { marketingAttributionV1 } from './marketing-attribution';

// The Webflow script writes `encodeURIComponent(JSON.stringify(attribution))` only after
// marketing consent, on `.vrplatform.app` with `Secure; SameSite=Lax` and a 90-day max-age.
export const MARKETING_ATTRIBUTION_COOKIE_NAME = 'vrp_marketing_attribution_v1';

export const marketingAttributionCookieValue = z
  .string()
  .max(4095)
  .transform((value, ctx) => {
    try {
      return JSON.parse(decodeURIComponent(value));
    } catch {
      ctx.addIssue({
        code: 'custom',
        message: 'Marketing attribution cookie is not encoded JSON',
      });
      return z.NEVER;
    }
  })
  .pipe(marketingAttributionV1);
